import { createContext } from 'react';
import type { TExperienceChatContextValue } from './ExperienceChat.types.ts';
import type { TConversationThreadContextValue } from '#providers/conversations/index.ts';

export const ExperienceChatContext = createContext<
  TExperienceChatContextValue | undefined
>(undefined);

export const ExperienceChatThreadContext = createContext<
  TConversationThreadContextValue | undefined
>(undefined);
